// Styles for PrivacyRightsComponent go here.
import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';
export const StyledPrivacyRightsComponent = styled.div`
  padding: 0 ${toRem(25)};
  .form-container {
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: ${toRem(24)};

    @media screen and (max-width: ${toRem(1200)}) {
      flex-wrap: wrap;
    }
    .form-element {
      &.unAuth-element {
        @media screen and (min-width: ${toRem(1200)}) {
          width: 50%;
        }
      }
      padding: ${toRem(24)};
      flex-shrink: 1;
      border-radius: ${toRem(16)};
      background: var(--Colors-neutral-10, #f4f4f4);
      @media screen and (max-width: ${toRem(1200)}) {
        width: 100%;
      }
      .m-input-text-field {
        width: 66%;
        @media screen and (max-width: ${toRem(720)}) {
          width: 100%;
        }
        height: ${toRem(52)};
        background-color: white;
      }
      .optInOptOutRadioLabel {
        font-weight: 500;
        line-height: 150%;
      }
    }
  }
  button {
    @media screen and (max-width: ${toRem(768)}) {
      width: 100%;
      &.sbt-btn {
        margin: ${toRem(4)} 0 ${toRem(16)} 0;
      }
    }
    &.disable-btn {
      background-color: #c4c4c4;
      min-width: ${toRem(248)};
      cursor: no-drop;
    }
  }
`;
